module.exports = __webpack_public_path__ + "img/17@2x.d5f8bb60.png";